import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import UploadDoc from '../../components/UploadDoc';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withRouter } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';


const styles = theme => ({
    root: {
        width: '450px',
        minWidth: '350px',
        display: 'column',
        alignItem: 'center'
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    InputLabel:{
        fontSize: '14px',
    },
    rightInput:{
        marginLeft: '50px',
    },
    country:{
        marginTop: '15px',
        marginBottom: '10px',
    },
    hkidPassport:{
        marginTop: '15px',
        marginBottom: '10px',
    },
});

class UserInfo extends Component {
    state = {
      fullName: this.props.fullName,
      fullName_: this.props.fullName_,
      //country: this.props.country,
      //region: '',
      postalCode: this.props.postalCode,
      hkid: this.props.hkid,
      address: this.props.address,
      passport: this.props.passport,
      registeredAddress: this.props.registeredAddress,
      companyIncorporationLocation : this.props.companyIncorporationLocation,
      country: this.props.country,
      email: this.props.email,
    };

    componentDidMount(){
        this.props.onUserInfoRef(this);
        this.setState({
            fullName: this.props.fullName,
            email: this.props.email,
            hkid: this.props.hkid,
            passport: this.props.passport,
            companyIncorporationLocation: this.props.companyIncorporationLocation,
            registeredAddress:this.props.registeredAddress,
            telephone: this.props.telephone,
            address: this.props.address,
            country: this.props.country,
        });

        // if(this.props.claimantUniqueId == this.state.uniqueId){

        //     this.setState({
                
        //     })  
        // }else if(this.props.respondentUniqueId == this.state.uniqueId){

        //     this.setState({
                
        //     })
        // }
    }
    componentWillUnmount() {
        this.props.onUserInfoRef(undefined);
      }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    }

    selectCountry = val => {
        this.setState({ companyIncorporationLocation: val });
    }

    submitHandler = (event) => {
        event.preventDefault();
        //this.props.onSetRedirectPath('/home');
        //this.setState({loginInProgress: true,})
        this.props.uploadDocs(this.props.files, this.props.match.params.id, this.props.userType);
        //this.props.history.push(this.props.authRedirect);    
    };

    updateUserInfoSubmitHandler = () => {
        let userData = {
            email_address: this.state.email,
            name: this.state.fullName,
            hkid: this.state.hkid,
            passport: this.state.passport,
            company_incorporation_location: this.state.companyIncorporationLocation,
            registered_address: this.state.registeredAddress,
            telephone: this.state.telephone,
            refToken: localStorage.getItem('token'),
            address: this.state.address,
        }
        this.props.updateUserInfo(userData, this.props.handleComplete);
    }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        return(
            <form className={classes.root}>
                <Card className={classes.card}>
                    <CardContent>

                        {
                            (this.props.fullName != null) ? 
                            (<FormControl className={classes.margin} required fullWidth>
                                <InputLabel className={classes.InputLabel} htmlFor="full-name">Full Name</InputLabel>
                                <Input
                                    id="full-name"
                                    value = {this.state.fullName}
                                    onChange = {this.handleChange('fullName')}
                                    inputProps={{
                                        style: {fontSize: 14} 
                                    }}
                                />
                            </FormControl>):null
                        }

                        {
                            (this.props.fullName_ != null) ? 
                            (<FormControl className={classes.margin} required fullWidth>
                                <InputLabel className={classes.InputLabel} htmlFor="full-name">Full Name</InputLabel>
                                <Input
                                    id="full-name"
                                    value = {this.state.fullName}
                                    onChange = {this.handleChange('fullName')}
                                    inputProps={{
                                        style: {fontSize: 14} 
                                    }}
                                />
                            </FormControl>):null
                        }

                        {
                            (this.props.address != null) ? 
                            (
                                <FormControl required fullWidth>
                                    <InputLabel className={classes.InputLabel} htmlFor="address">Address</InputLabel>
                                    <Input
                                        id="address"
                                        value = {this.state.address}
                                        onChange = {this.handleChange('address')}
                                        inputProps={{
                                            style: {fontSize: 14} 
                                        }}
                                    />
                                </FormControl>
                            ) 
                            :
                            null
                        }

                        {
                            (this.props.registeredAddress != null) ? 
                            (
                                <FormControl required fullWidth>
                                    <InputLabel className={classes.InputLabel} htmlFor="address">Address</InputLabel>
                                    <Input
                                        id="address"
                                        value = {this.state.registeredAddress}
                                        onChange = {this.handleChange('registeredAddress')}
                                        inputProps={{
                                            style: {fontSize: 14} 
                                        }}
                                    />
                                </FormControl>
                            ) 
                            :
                            null
                        }

                         {
                            (this.props.companyIncorporationLocation != null) ? 
                            (
                                <FormControl required fullWidth>
                                    <InputLabel className={classes.InputLabel} htmlFor="location">Location</InputLabel>
                                    <Input
                                        id="location"
                                        value = {this.state.companyIncorporationLocation}
                                        onChange = {this.handleChange('companyIncorporationLocation')}
                                        inputProps={{
                                            style: {fontSize: 14} 
                                        }}
                                    />
                                </FormControl>
                            ) 
                            :
                            null
                        }

                    </CardContent>
                    
                </Card>
            </form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        //fullName: state.userInfo.fullName,
        //fullName: (state.caseInfo.userType !== null || state.caseInfo.userType !== undefined)  ? (state.caseInfo.userType === 'claimant' ? state.caseInfo.claimant_name : state.caseInfo.respondent_name) : null,
        fullName: (state.caseInfo.caseData !== null)  ? state.caseInfo.caseData.a3 : (state.caseInfo.userType !== null || state.caseInfo.userType !== undefined)  ? (state.caseInfo.userType === 'claimant' ? state.caseInfo.claimant_name : state.caseInfo.respondent_name) : null,
        address: (state.caseInfo.caseData !== null)  ? state.caseInfo.caseData.a3a : state.userInfo.address,
        email: state.userInfo.email,
        hkid: state.userInfo.hkid,
        passport: state.userInfo.passport,
        companyIncorporationLocation: state.userInfo.companyIncorporationLocation,
        registeredAddress: state.userInfo.registeredAddress,
        telephone: state.userInfo.telephone,
        // address: state.userInfo.address,
        country: state.userInfo.country,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        caseInfo:state.caseInfo,
        caseData: state.caseInfo.caseData
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUserInfo: (userData, handleComplete) => dispatch(actions.updateUserInfo(userData, handleComplete)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(UserInfo)));
